export default __webpack_public_path__ + "static/media/error-1-_3_.8b298732.svg";